module.exports = __webpack_public_path__ + "static/img/Luke_Parker_desktop.22e6e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke_Parker_desktop.jpg
// module id = nc0F
// module chunks = 0